import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-bold" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-3 my-4" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "py-2" }
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = { class: "col-span-2" }
const _hoisted_8 = { class: "text-next-bri col-span-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Radio = _resolveComponent("Radio")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("form", {
    ref: "form",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "" }, "Esportazione", -1)),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.titolo), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "font-bold py-2" }, "Tipologia del file", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Radio, {
            id: "xlsx",
            value: "xlsx",
            name: "type",
            modelValue: _ctx.tipologia_file,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tipologia_file) = $event)),
            checkClass: "w-3 h-3"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Excel ")
            ])),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Radio, {
            id: "pdf",
            value: "pdf",
            name: "type",
            modelValue: _ctx.tipologia_file,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tipologia_file) = $event)),
            checkClass: "w-3 h-3"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("PDF")
            ])),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Radio, {
            id: "both",
            value: "both",
            name: "type",
            modelValue: _ctx.tipologia_file,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tipologia_file) = $event)),
            checkClass: "w-3 h-3"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Excel e PDF ")
            ])),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "font-bold py-2" }, "Template", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.template) = $event)),
          class: "p-2 my-2 w-full",
          name: "template"
        }, _cache[10] || (_cache[10] = [
          _createStaticVNode("<option disabled value=\"\">Seleziona un template</option><option value=\"0\">Interno BU (Esporta in base ai campi predefiniti della BU di progetto)</option><option value=\"1\">Cliente BU (Esporta in base ai campi predefiniti della BU di progetto)</option><option value=\"2\">Entrambi BU</option><option value=\"3\">Personalizzato cliente (Esporta solo le colonne di vendita che vedi a schermo) </option><option value=\"4\">Personalizzato (Esporta solo le colonne che vedi a schermo)</option>", 6)
        ]), 512), [
          [_vModelSelect, _ctx.template]
        ])
      ]),
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('chiudi'))),
        class: "py-2 px-4 w-full"
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode(" Chiudi ")
        ])),
        _: 1
      }),
      _createVNode(_component_NextButton, {
        variant: "primary",
        disabled: _ctx.loading,
        class: "py-2 px-4 w-full flex items-center justify-center"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_Spinner, { class: "w-4 h-4 mr-4" }, null, 512), [
            [_vShow, _ctx.loading]
          ]),
          _cache[13] || (_cache[13] = _createTextVNode(" Esporta "))
        ]),
        _: 1
      }, 8, ["disabled"]),
      _withDirectives(_createElementVNode("p", _hoisted_8, [
        _cache[15] || (_cache[15] = _createTextVNode(" Il file è in generazione,")),
        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
        _cache[17] || (_cache[17] = _createTextVNode("attendi il completamento e scaricalo nella ")),
        _createVNode(_component_RouterLink, {
          to: {name: 'DownloadCenter'},
          target: "_blank",
          class: "underline"
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("sezione download. ")
          ])),
          _: 1
        })
      ], 512), [
        [_vShow, _ctx.showSuccess]
      ]),
      _withDirectives(_createElementVNode("p", { class: "text-center text-next-orange col-span-2" }, _toDisplayString(_ctx.error), 513), [
        [_vShow, _ctx.error]
      ])
    ])
  ], 544))
}